import React from 'react';

export default function CancellationRefundPage() {
  return (
    <div className="cs_refund_page">
      <div className="container">
        <div className="cs_refund_container">
          <h1>Cancellation & Refund Policy</h1>
          <p className="cs_last_updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Order Cancellation</h2>
            <h3>Before Shipment</h3>
            <ul>
              <li>Orders can be cancelled within 2 hours of placement</li>
              <li>Full refund will be processed within 5-7 business days</li>
              <li>No cancellation charges apply</li>
              <li>Contact customer support immediately for cancellation</li>
            </ul>
            
            <h3>After Shipment</h3>
            <ul>
              <li>For shipped orders, please receive the product and initiate a return request if unsatisfied</li>
              <li>Contact us to guide you through the return process smoothly</li>
            </ul>
          </section>

          <section>
            <h2>2. Return Policy</h2>
            <h3>Eligible Returns</h3>
            <ul>
              <li>Products with manufacturing defects</li>
              <li>Wrong product delivered or damaged products during shipping</li>
              <li>If you are generally unsatisfied with the purchase within the 7-day period</li>
            </ul>
            
            <h3>Return Timeframe</h3>
            <ul>
              <li>Returns must be initiated within 7 days of delivery</li>
              <li>To help us process it, please retain the original packaging where possible</li>
            </ul>
            
            <h3>Customer Satisfaction Guarantee</h3>
            <ul>
              <li>We prioritize your wellness journey. Even if the product has been opened, please reach out to us within 7 days. Our support team will evaluate your case for a fair refund or a hassle-free replacement.</li>
            </ul>
          </section>

          <section>
            <h2>3. Return Process</h2>
            <ol>
              <li><strong>Contact Support:</strong> Email support@ayumedix.com or WhatsApp <a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer">+91 93139 89270</a></li>
              <li><strong>Return Authorization:</strong> Receive return authorization number (RMA)</li>
              <li><strong>Package Product:</strong> Pack in original packaging with RMA number</li>
              <li><strong>Ship Back:</strong> Send to our return address (provided with RMA)</li>
              <li><strong>Inspection:</strong> Product will be inspected upon receipt</li>
              <li><strong>Refund Processing:</strong> Refund processed after successful inspection</li>
            </ol>
          </section>

          <section>
            <h2>4. Refund Policy</h2>
            <h3>Refund Methods</h3>
            <ul>
              <li>Refunds are processed back to the original payment method securely</li>
              <li>For specific payment issues, bank transfer options may be provided</li>
              <li>Refunds will be processed within 5-7 business days</li>
            </ul>
            
            <h3>Refund Amount</h3>
            <ul>
              <li>Full product price will be refunded for defective, wrong items, or valid dissatisfaction claims</li>
              <li>We believe in offering fair refund values based on a straightforward inspection</li>
            </ul>
          </section>

          <section>
            <h2>5. Exchange Policy</h2>
            <ul>
              <li>Exchanges available for defective products only</li>
              <li>Same product will be sent as replacement</li>
              <li>No exchanges for different products or variants</li>
              <li>Exchange shipping is free for defective items</li>
            </ul>
          </section>

          <section>
            <h2>6. Damaged Products</h2>
            <h3>During Shipping</h3>
            <ul>
              <li>Report within 24 hours of delivery</li>
              <li>Provide photos of damaged packaging and product</li>
              <li>Free replacement or full refund provided</li>
              <li>No return shipping charges</li>
            </ul>
            
            <h3>Manufacturing Defects</h3>
            <ul>
              <li>Report within 7 days of delivery</li>
              <li>Describe the defect in detail</li>
              <li>Free replacement provided after verification</li>
            </ul>
          </section>

          <section>
            <h2>7. Wrong Product Delivered</h2>
            <ul>
              <li>Contact us immediately upon delivery</li>
              <li>Provide order number and product details</li>
              <li>Correct product will be shipped free of charge</li>
              <li>Wrong product pickup arranged at no cost</li>
            </ul>
          </section>

          <section>
            <h2>8. Refund Processing Time</h2>
            <table style={{width: '100%', borderCollapse: 'collapse', margin: '20px 0'}}>
              <thead>
                <tr style={{backgroundColor: '#f8f8f8'}}>
                  <th style={{padding: '12px', border: '1px solid #ddd', textAlign: 'left'}}>Payment Method</th>
                  <th style={{padding: '12px', border: '1px solid #ddd', textAlign: 'left'}}>Processing Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>Credit/Debit Cards</td>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>5-7 business days</td>
                </tr>
                <tr>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>UPI</td>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>3-5 business days</td>
                </tr>
                <tr>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>Net Banking</td>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>5-7 business days</td>
                </tr>
                <tr>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>Digital Wallets</td>
                  <td style={{padding: '12px', border: '1px solid #ddd'}}>3-5 business days</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section>
            <h2>9. Return Shipping</h2>
            <ul>
              <li>Customer bears return shipping cost for non-defective returns</li>
              <li>We provide prepaid return labels for our errors</li>
              <li>Use original packaging or similar protective packaging</li>
              <li>Insurance recommended for high-value returns</li>
            </ul>
          </section>

          <section>
            <h2>10. Special Circumstances</h2>
            <h3>Medical Reasons</h3>
            <ul>
              <li>Returns accepted for medical contraindications</li>
              <li>Medical certificate may be required</li>
              <li>Case-by-case evaluation</li>
            </ul>
            
            <h3>Quality Issues</h3>
            <ul>
              <li>Immediate replacement for quality issues</li>
              <li>Investigation conducted for recurring issues</li>
              <li>Additional compensation may be provided</li>
            </ul>
          </section>

          <section>
            <h2>11. Contact for Returns & Refunds</h2>
            <p>For return and refund queries:</p>
            <p>Email: support@ayumedix.com<br/>
            WhatsApp: <a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer">+91 93139 89270</a><br/>
            Support Hours: Mon-Sat, 9 AM - 8 PM IST</p>
            
            <p><strong>Return Address:</strong><br/>
            Ayumedix Healthcare<br/>
            Returns Department<br/>
            Gondal, Gujarat<br/>
            WhatsApp: <a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer">+91 93139 89270</a></p>
          </section>

          <section>
            <h2>12. Policy Updates</h2>
            <p>This policy may be updated periodically. Changes will be communicated via email and website notifications. Continued use of our services constitutes acceptance of updated terms.</p>
          </section>
        </div>
      </div>

      <style jsx>{`
        .cs_refund_page {
          min-height: 100vh;
          background: #f8f8f8;
          padding: 120px 0 80px;
        }
        .cs_refund_container {
          max-width: 800px;
          margin: 0 auto;
          background: #ffffff;
          padding: 50px;
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(18, 18, 18, 0.08);
        }
        .cs_refund_container h1 {
          color: #121212;
          font-size: 36px;
          font-weight: 700;
          margin-bottom: 10px;
          text-align: center;
        }
        .cs_last_updated {
          text-align: center;
          color: #666;
          margin-bottom: 40px;
          font-style: italic;
        }
        .cs_refund_container section {
          margin-bottom: 35px;
        }
        .cs_refund_container h2 {
          color: #121212;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 15px;
          border-bottom: 2px solid #0b5e4b;
          padding-bottom: 5px;
        }
        .cs_refund_container h3 {
          color: #121212;
          font-size: 18px;
          font-weight: 600;
          margin: 20px 0 10px;
        }
        .cs_refund_container p {
          color: #4f4747;
          line-height: 1.6;
          margin-bottom: 15px;
        }
        .cs_refund_container ul, .cs_refund_container ol {
          color: #4f4747;
          line-height: 1.6;
          margin-left: 20px;
        }
        .cs_refund_container li {
          margin-bottom: 8px;
        }
        .cs_refund_container ol li {
          margin-bottom: 12px;
        }
        @media (max-width: 768px) {
          .cs_refund_page {
            padding: 100px 0 50px;
          }
          .cs_refund_container {
            margin: 0 20px;
            padding: 30px 25px;
          }
          .cs_refund_container h1 {
            font-size: 28px;
          }
          .cs_refund_container h2 {
            font-size: 20px;
          }
          .cs_refund_container table {
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
}